// extracted by mini-css-extract-plugin
export default {"techBody":"Tools_techBody__aeW+H","techStackIcon":"Tools_techStackIcon__bA7GM"};